import { render, staticRenderFns } from "./FavoriteInput.vue?vue&type=template&id=9d2129e2"
import script from "./FavoriteInput.vue?vue&type=script&lang=js"
export * from "./FavoriteInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports